var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.12025 14.1482C4.1133 14.1421 4.1065 14.1361 4.09984 14.1302V14.0272L3.83623 13.7636C2.39552 12.3229 1.5665 10.4149 1.5665 8.4V8.14737C1.69211 4.24257 5.02101 1.03333 8.93317 1.03333C9.55059 1.03333 10.3377 1.24515 11.1065 1.65909C11.8429 2.0556 12.4984 2.60339 12.9351 3.22713C13.4083 4.27379 14.9116 4.25737 15.3525 3.17788C15.7207 2.52332 16.3603 1.95126 17.1049 1.53603C17.873 1.10766 18.656 0.9 19.1998 0.9C23.2271 0.9 26.4406 4.09104 26.5665 8.14692V8.4C26.5665 10.563 25.7281 12.4504 24.325 13.7366L24.0332 14.0041V14.0985C24.0191 14.1104 24.0047 14.1225 23.99 14.1349C23.782 14.3102 23.4997 14.5534 23.1634 14.8459C22.49 15.4314 21.5879 16.225 20.6048 17.0915C20.2897 17.3692 19.9663 17.6543 19.6393 17.9427C17.9255 19.454 16.1132 21.0522 14.885 22.113C14.4204 22.4957 13.7125 22.4957 13.2479 22.1129C11.783 20.8477 9.45547 18.8195 7.47542 17.089C6.48406 16.2226 5.58041 15.4314 4.91646 14.8486C4.5844 14.5571 4.31276 14.3182 4.12025 14.1482Z",
    stroke: "#6B7280",
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart1);
export default __webpack_public_path__ + "static/media/heart_1.4e8549f8c1925b302cf097808c084688.svg";
export { ForwardRef as ReactComponent };